export default __webpack_public_path__ + "static/media/Rectangle108@2x.a34db332.png";